import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component } from '@angular/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, NgSelectModule],
  selector: 'svg-validate-svg',
  template: `
  <div class="svg-container">
  <svg width="78px" height="78px" viewBox="0 0 78 78" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <!-- Generator: Sketch 52.3 (67297) - http://www.bohemiancoding.com/sketch -->
  <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="04_Icons/Hero/validate_policy" transform="translate(-1.000000, -1.000000)">
          <g id="Group" transform="translate(1.000000, 1.000000)">
              <path d="M70.125,39 L78,39 C78,49.7500537 74.1875381,58.9374619 66.5625,66.5625 C58.9374619,74.1875381 49.7500537,78 39,78 C28.2499462,78 19.0625381,74.1875381 11.4375,66.5625 C3.81246188,58.9374619 0,49.7500537 0,39 C0,28.2499462 3.81246188,19.0625381 11.4375,11.4375 C19.0625381,3.81246188 28.2499462,0 39,0 C44.000025,0 48.8749762,0.99999 53.625,3 L47.625,9 C44.8749862,8.24999625 42.000015,7.875 39,7.875 C30.3749569,7.875 23.0312803,10.9062197 16.96875,16.96875 C10.9062197,23.0312803 7.875,30.3749569 7.875,39 C7.875,47.6250431 10.9062197,54.9687197 16.96875,61.03125 C23.0312803,67.0937803 30.3749569,70.125 39,70.125 C47.6250431,70.125 54.9687197,67.0937803 61.03125,61.03125 C67.0937803,54.9687197 70.125,47.6250431 70.125,39 Z" id="ion-android-checkmark-circle---Ionicons" fill="#737373"></path>
              <polygon id="ion-android-checkmark-circle---Ionicons-Copy" fill="#8DB602" points="21.6843854 31.1265823 34.2292359 43.5485232 69.3156146 9 75 14.628692 34.2292359 55 16 36.9493671"></polygon>
          </g>
      </g>
  </g>
</svg>
</div>`
})
export class ValidateSvgComponent {

}
